import { cn } from "@/lib/utils";

interface GradientLineProps {
  className?: string;
  width?: "full" | "2/3";
  startColor?: string;
  endColor?: string;
}

export function GradientLine({
  className,
  width = "2/3",
  startColor = "0,244,185", // Default neon green
  endColor = "14,165,233", // Default blue (#0EA5E9)
}: GradientLineProps) {
  return (
    <div className="absolute inset-x-0 bottom-0">
      <div className="absolute bottom-0 right-4 mt-[2px] flex h-8 items-end overflow-hidden w-2/3">
        <div className="flex -mb-px h-[2px] w-full">
          <div className="w-full flex-none blur-sm [background-image:linear-gradient(90deg,rgba(0,244,185,0)_0%,rgba(0,244,185,0.5)_32.29%,#0EA5E9_67.19%,rgba(56,189,248,0)_100%)]"></div>
          <div className="-ml-[100%] w-full flex-none blur-[1px] [background-image:linear-gradient(90deg,rgba(0,244,185,0)_0%,rgba(0,244,185,0.5)_32.29%,#0EA5E9_67.19%,rgba(56,189,248,0)_100%)]"></div>
        </div>
      </div>
    </div>
  );
}
